import BundleConfiguratorContent from "./bundle-configurator-content.jsx";

import { h, render } from "preact";
import storefront from "../../helpers/storefront/index.js";
import * as queries from "../../helpers/storefront/queries.js";

class BundleConfigurator extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.container = this.querySelector("[data-bundle-configurator-container]");

    this.init();
  }

  init = async () => {
    if (this.data.productsBundle?.length <= 0) return;

    const response = await storefront.request({
      query: queries.products,
      variables: {
        ids: this.data.productsBundle.map((item) =>
          encodeId(item.id, "Product"),
        ),
      },
    });

    const BundleConfiguratorComponent = () => {
      return (
        <BundleConfiguratorContent
          data={this.data}
          form={this.closest("product-form")}
          bundle={response?.data.nodes}
          parent={this.mainBundle}
        />
      );
    };

    this.container && render(<BundleConfiguratorComponent />, this.container);
  };
}

if (!customElements.get("bundle-configurator")) {
  customElements.define("bundle-configurator", BundleConfigurator);
}
